var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSpecial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    fill: "url(#paint0_linear_538_1050)",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    stroke: "url(#paint1_linear_538_1050)",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    stroke: "url(#paint2_linear_538_1050)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4068 38H21.6188L13.6108 25.876V38H8.82275V18.344H13.6108L21.6188 30.524V18.344H26.4068V38Z",
    fill: "url(#paint3_linear_538_1050)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4068 38H21.6188L13.6108 25.876V38H8.82275V18.344H13.6108L21.6188 30.524V18.344H26.4068V38Z",
    fill: "url(#paint4_linear_538_1050)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9334 38.196C35.0854 38.196 33.3868 37.7666 31.8374 36.908C30.3068 36.0493 29.0841 34.8546 28.1694 33.324C27.2734 31.7746 26.8254 30.0386 26.8254 28.116C26.8254 26.1933 27.2734 24.4666 28.1694 22.936C29.0841 21.4053 30.3068 20.2106 31.8374 19.352C33.3868 18.4933 35.0854 18.064 36.9334 18.064C38.7814 18.064 40.4708 18.4933 42.0014 19.352C43.5508 20.2106 44.7641 21.4053 45.6414 22.936C46.5374 24.4666 46.9854 26.1933 46.9854 28.116C46.9854 30.0386 46.5374 31.7746 45.6414 33.324C44.7454 34.8546 43.5321 36.0493 42.0014 36.908C40.4708 37.7666 38.7814 38.196 36.9334 38.196ZM36.9334 33.828C38.5014 33.828 39.7521 33.3053 40.6854 32.26C41.6374 31.2146 42.1134 29.8333 42.1134 28.116C42.1134 26.38 41.6374 24.9986 40.6854 23.972C39.7521 22.9266 38.5014 22.404 36.9334 22.404C35.3468 22.404 34.0774 22.9173 33.1254 23.944C32.1921 24.9706 31.7254 26.3613 31.7254 28.116C31.7254 29.852 32.1921 31.2426 33.1254 32.288C34.0774 33.3146 35.3468 33.828 36.9334 33.828Z",
    fill: "url(#paint5_linear_538_1050)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9334 38.196C35.0854 38.196 33.3868 37.7666 31.8374 36.908C30.3068 36.0493 29.0841 34.8546 28.1694 33.324C27.2734 31.7746 26.8254 30.0386 26.8254 28.116C26.8254 26.1933 27.2734 24.4666 28.1694 22.936C29.0841 21.4053 30.3068 20.2106 31.8374 19.352C33.3868 18.4933 35.0854 18.064 36.9334 18.064C38.7814 18.064 40.4708 18.4933 42.0014 19.352C43.5508 20.2106 44.7641 21.4053 45.6414 22.936C46.5374 24.4666 46.9854 26.1933 46.9854 28.116C46.9854 30.0386 46.5374 31.7746 45.6414 33.324C44.7454 34.8546 43.5321 36.0493 42.0014 36.908C40.4708 37.7666 38.7814 38.196 36.9334 38.196ZM36.9334 33.828C38.5014 33.828 39.7521 33.3053 40.6854 32.26C41.6374 31.2146 42.1134 29.8333 42.1134 28.116C42.1134 26.38 41.6374 24.9986 40.6854 23.972C39.7521 22.9266 38.5014 22.404 36.9334 22.404C35.3468 22.404 34.0774 22.9173 33.1254 23.944C32.1921 24.9706 31.7254 26.3613 31.7254 28.116C31.7254 29.852 32.1921 31.2426 33.1254 32.288C34.0774 33.3146 35.3468 33.828 36.9334 33.828Z",
    fill: "url(#paint6_linear_538_1050)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_1050",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_1050",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_538_1050",
    x1: 28,
    y1: 1.24726e-8,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_538_1050",
    x1: 7,
    y1: 7,
    x2: 28.3018,
    y2: 48.5893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_538_1050",
    x1: 27.5,
    y1: 7,
    x2: 27.5,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_538_1050",
    x1: 7,
    y1: 7,
    x2: 28.3018,
    y2: 48.5893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_538_1050",
    x1: 27.5,
    y1: 7,
    x2: 27.5,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8A00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSpecial);
export default __webpack_public_path__ + "static/media/no-special.b4a93534d2a72e0d6d32791835d5c8cc.svg";
export { ForwardRef as ReactComponent };